<template>
  <div class="container">
    <div class="content py-4">
      <h2 class="mb-4">簽名</h2>
      <form action="/" id="uploadForm" class="text-start">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="" id="agreeContract">
          <label class="form-check-label" for="agreeContract">
            同意合約內容。<div class="d-sm-inline d-block">Agree to the contract content.</div>
          </label>
        </div>
        <br>
        <div class="form-check mb-5">
          <input class="form-check-input" type="checkbox" value="" id="agreePersonal">
          <label class="form-check-label" for="agreePersonal">
            同意個人資料使用條款。<div class="d-sm-inline d-block">Agree to the profile terms of use.</div>
          </label>
        </div>

        <div class="file-box col-12 mb-3">
          <div class="mb-3">
            <label for="img1" class="form-label font-weight-semibold">1. 身分證正面影本 <span class="text-danger"> （ 若以法人身分簽約，不需要上傳身分證影本資料；若以自然人身分簽約，則務必上傳，此合約方為有效。 ） </span> </label>
            <input type="file" data-img="1" multiple="multiple" id="img1" class="file-input form-control"
              @change="fileSelected">
          </div>
          <img v-if="image1" :src="image1" class="img-fluid" />
        </div>
        <div class="file-box col-12 mb-3">
          <div class="mb-3">
            <label for="img2" class="form-label font-weight-semibold">2. 身分證背面影本 <span class="text-danger"> （ 若以法人身分簽約，不需要上傳身分證影本資料；若以自然人身分簽約，則務必上傳，此合約方為有效。 ） </span> </label>
            <input type="file" data-img="2" id="img2" multiple="multiple" class="file-input form-control"
              @change="fileSelected">
          </div>
          <img v-if="image2" :src="image2" class="img-fluid" />
        </div>
        <div class="file-box col-12 mb-3">
          <div class="mb-3">
            <label for="img3" class="form-label font-weight-semibold">3. 存摺局帳號影本 </label>
            <input type="file" data-img="3" id="img3" multiple="multiple" required class="file-input form-control"
              @change="fileSelected">
          </div>
          <img v-if="image3" :src="image3" class="img-fluid" />
        </div>
      </form>
      <br>
       <div>
         <VueSignaturePad height="400px" width='auto' id="signature" ref="signaturePad" />
         <span class="text-danger"> 可手寫簽名,或直接上傳簽名圖檔(或公司簽約印章圖檔)完成簽約。 </span>
         <input type="file" @change="uploadImage" accept="image/*" class="form-control my-3" />

         <div class="py-3 mt-3">
           <button @click="undo" class="btn btn-warning me-2 py-2 px-4">復原</button>
           <button @click="save" :disabled="isSubmitDisabled" class="btn btn-primary py-2 px-4">
             {{ isSubmitDisabled ? '已送出' : '送出' }}
           </button>
         </div>
       </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { VueSignaturePad } from 'vue-signature-pad';
import axios from 'axios';
const token = localStorage.getItem('token');
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

var currentURL = (document.URL);
const sgid = currentURL.split('://')[1].split('/')[3];
const uuid = currentURL.split('://')[1].split('/')[2];
const baseUrl = process.env.VUE_APP_API_URL
const postSignUrl = `${baseUrl}/api/v1/signings/signature`

export default defineComponent({
  name: 'signView',
  components: { VueSignaturePad },
  data() {
    return {
      image1: '',
      image2: '',
      image3: '',
      isSubmitDisabled: false

    };
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const vm = this;
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      const agreeContract = document.getElementById("agreeContract").checked
      const agreePersonal = document.getElementById("agreePersonal").checked
      const uploadForm = document.getElementById("uploadForm")

      const img1Input = document.getElementById("img1")
      const img2Input = document.getElementById("img2")
      const img3Input = document.getElementById("img3")

      if (uploadForm.checkValidity()) {

        if (agreeContract && agreePersonal && !isEmpty) {
          vm.isSubmitDisabled = true

          const formData = new FormData();
          formData.append("sgid", sgid);
          formData.append("uuid", uuid);
          formData.append("signature[signature_content]", data);
          Array.from(img1Input.files).forEach((item) => formData.append("digital_contract[id_card_images][]", item))
          Array.from(img2Input.files).forEach((item) => formData.append("digital_contract[id_card_back_images][]", item))
          Array.from(img3Input.files).forEach((item) => formData.append("digital_contract[bank_book_images][]", item))
          axios
            .post(postSignUrl, formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
            .then(response => {
              console.log('res after save', response);

              if (response.status == 200) {
                this.$router.push({ name: 'success' });
              }
              else {
                this.$router.push({ name: 'failed' });
              }
            }).catch((error) => {
              console.log('error after sign', error);
              if (error.response.status == 304) {
                this.$router.push({
                  name: 'result', query: {
                    isSigned: true,
                  }
                });
              }
            })

        } else {
          if (!isEmpty) {
            alert("需同意合約內容及同意個人資料使用條款")
          } else {
            alert("簽名不得空白")
          }
        }
      } else {
        // alert('')
        console.log('alert');
        uploadForm.reportValidity()
      }

    },
    fileSelected(e) {
      const file = e.target.files.item(0);
      const idx = e.target.dataset.img
      const vm = this
      const reader = new FileReader();
      reader.addEventListener('load', function (e) { vm.imageLoaded(e, idx) });
      reader.readAsDataURL(file);
    },
    imageLoaded(e, idx) {
      let outputImg = `image${idx}`
      this[outputImg] = e.target.result;
    },
    async uploadImage(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          const canvasParent = document.getElementById("signature");
          let setImgWidth = canvasParent.clientWidth - 5;
          if (setImgWidth > 420) {
            setImgWidth = 400
          }
          const canvas = document.getElementsByTagName("canvas")[0]; 
          const ctx = canvas.getContext("2d");
          var ratio = img.height / img.width;
          console.log('ratio',ratio)
          let scaledheight = setImgWidth * ratio;  

          ctx.clearRect(0, 0, canvas.width, canvas.height);         

          // 繪製圖片 (從左上角開始)
          ctx.drawImage(img, 0,0, setImgWidth, scaledheight);

          // 讓 VueSignaturePad 使用這張調整過的圖片
          this.$refs.signaturePad.fromDataURL(canvas.toDataURL());
        };
      };
      reader.readAsDataURL(file);
    },
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.form-check {
  font-size: 20px;
  display: inline-block;
  margin-bottom: 16px;
}

#signature {
  width: 100%;

  border: solid 3px #9fa9b8f1;
  border-radius: 5px;
  background: rgba(240, 248, 255, 0.916)
  /* background-image: linear-gradient(white, white),
  radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box; */
}

.file-box {
  border: dashed 2px #c1c8d2f1;
  border-radius: 5px;
  padding: 15px;


}

.file-input {
  max-width: 300px;
}

.content {
  /* background-color: #def0f3; */
}

/* h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>
